// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"view-column"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 21L5 3M12 21L12 3M19 21L19 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ViewColumnIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'view-column',
    ref,
    icon: element,
  },
));

ViewColumnIcon.displayName = 'ViewColumnIcon';

export default ViewColumnIcon;
